import { render } from "./Investments.vue?vue&type=template&id=dfb4112e"
import script from "./Investments.vue?vue&type=script&lang=js"
export * from "./Investments.vue?vue&type=script&lang=js"
script.render = render

export default script